export default __webpack_public_path__ + "static/media/wp-morphext.cfe3c3a5.svg";